function Home() {
  return (
    <div className="container">

      {/* HERO */}
      <section id="hero">
        <h1>Scott Smith</h1>
        <p>Business Student | University of Redlands</p>
        <a href="/resume.pdf" download>Download Resume</a>
      </section>

      {/* EXPERIENCE */}
      <section id="experience">
        <h2>Experience</h2>

        <div className="job">
          <h3>Boat Attendant — Los Gatos Recreation</h3>
          <p>San Jose, CA | Summer 2026</p>
          <ul>
            <li>Licensed Boat Attendant in Los Gatos, California</li>
            <li>Work front desk sales assisting with boat & kayak rentals</li>
            <li>Oversee children at boating day camp - facilitating activities and maintaining safety.</li>
          </ul>
        </div>

        <div className="job">
          <h3>Event Services Specialist</h3>
          <p>University of Redlands | January 2025 - April 2026</p>
          <ul>
            <li>Assist in set ups, tear downs, and checkups on on-campus and off-campus events.</li>
            <li>Manage phone calls with any questions with events with the University.</li>
          </ul>
        </div>

        <div className="job">
          <h3>VP / Social Chair — Kappa Sigma Sigma</h3>
          <p>University of Redlands | Jan 2025-April 2026</p>
          <ul>
            <li>Overseeing chapter operations within the Fraternity brothers.</li>
            <li>Work with volunteering, social events, and recruitment.</li>
          </ul>
        </div>

      </section>
{/* ABOUT */}
      <section id="about">
        <h2>About</h2>
        <p>Dean's List Business Student at the University of Redlands. High school graduate from Bellarmine College Preparatory in San Jose, California. 
        Hard-working, dedicated employee who has worked a range of part-time jobs. Developed skills in communication, event services, customer service and working with children.</p>
      </section>

      {/* PROJECTS */}
      <section id="projects">
        <h2>Projects</h2>

        <div className="project">
          <h3>TripIQ</h3>
          <p>A WIP travel app coded to track travel habits and spending deployed on Netlify.</p>
          <a href="https://your-tripiq-link.netlify.app" target="_blank" rel="noreferrer">View Live</a>
        </div>

      </section>

      {/* CONTACT */}
      <section id="contact">
        <h2>Contact</h2>
        <a href="mailto:sjsmithusa@gmail.com">sjsmithusa@gmail.com</a>
        <br />
        <a href="https://www.linkedin.com/in/scott-smith11/" target="_blank" rel="noreferrer">LinkedIn</a>
      </section>
    </div>
  );
}

export default Home;